import { writable } from "svelte/store";
import type {
  TUser,
  TFnWithoutPassportContext,
  TEvmContract,
} from "../utils/types";

import AbstractPassport from "../utils/classes/passport.abstract";
import {
  type TAirDrop,
  type TGetAssetsArgs,
  type TGetAssetsResult,
} from "@packages/passport-evm/src/utils/types";
import {
  type TSuiAirDropAsset,
  type TSuiAirDropCoin,
} from "@packages/passport-sui/src/utils/types";

export const accessTokenStore = writable<string | null>();
export const userStore = writable<TUser | null>(null);

export const suiPackageStore = writable<string>();
export const isLoggedInStore = writable<boolean>();
export const isLoggingInProcessStore = writable<boolean>();

export const fn = writable<{
  openUI: AbstractPassport["openUI"];
  close: AbstractPassport["close"];
  toastAlert: AbstractPassport["toastAlert"];
  logout: AbstractPassport["logout"];
  login: TFnWithoutPassportContext<AbstractPassport["login"]>;
  updateProfile: AbstractPassport["updateProfile"];
  deleteAccount: AbstractPassport["deleteAccount"];
  confirmAccount: AbstractPassport["confirmAccount"];
  sendTokens: AbstractPassport["sendTokens"];
  getCREDContract: () => Promise<TEvmContract> | string;
  checkMembership: AbstractPassport["checkMembership"];
  requestLoyaltyPoints?: (
    eventId: number,
    targetAddress: string
  ) => Promise<void>;
  getBalance: AbstractPassport["getBalance"];
}>();

export const suiFn = writable<{
  requestAirDropCoin: (data: TSuiAirDropCoin) => Promise<void>;
  requestAirDropAsset: (data: TSuiAirDropAsset) => Promise<void>;
}>();

export const evmFn = writable<{
  requestAirDrop: (airDropData: TAirDrop) => Promise<void>;
  getAssets: (params: TGetAssetsArgs) => Promise<TGetAssetsResult>;
}>();
